import * as React from "react"
import type { SVGProps } from "react"
const SvgParagraphJustifiedAlign = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M4 21.29a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 4 19.3h16q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm0-4a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 4 15.3h16q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm0-4a1 1 0 0 1-.71-.3 1 1 0 0 1-.29-.7q0-.43.29-.72A1 1 0 0 1 4 11.3h16q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm0-4a1 1 0 0 1-.71-.3A1 1 0 0 1 3 8.3q0-.43.29-.72A1 1 0 0 1 4 7.3h16q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3zm0-4a1 1 0 0 1-.71-.3A1 1 0 0 1 3 4.3q0-.44.29-.72A1 1 0 0 1 4 3.3h16q.42 0 .71.28.3.3.29.72c-.01.42-.1.52-.29.7a1 1 0 0 1-.71.3z" />
  </svg>
)
export default SvgParagraphJustifiedAlign
